exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.indented {\r\n    margin-left: 2vw;\r\n    margin-top: -13px;\r\n}\r\n\r\nli.indented {\r\n    margin-left: 2vh;\r\n}\r\n\r\nli.indented_more {\r\n    margin: 0 1vw 0 3vw;\r\n}\r\n\r\ni {\r\n    color: black;\r\n}\r\n\r\nh3.centering {\r\n    text-align: center; \r\n    color: #6E6E6E;\r\n}\r\n\r\n.line_right {\r\n    border-right: 1px #e0e0e0 solid;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/src/app/prototype/prototype.component.css
// module id = ../../../../../src/app/prototype/prototype.component.css
// module chunks = main